'use client'

import { ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v4'

export const ReCaptchaProvider = ({
  children,
  siteKey,
}: {
  children: ReactNode
  siteKey: string
}) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}
